// initial state
const state = () => ({
  profiles: [],
  randomProfiles: [],
});

// getters
const getters = {
  getProfiles: state => {
    return state.profiles;
  },
  getRandomProfiles: state => {
    return state.randomProfiles;
  },
  getRandomAvatars: state => {
    const profiles = state.randomProfiles;

    if (profiles.length >= 3) {
      return [
        profiles[0].avatar_url,
        profiles[1].avatar_url,
        profiles[2].avatar_url,
      ];
    }
    return [];
  },
};

// actions
const actions = {
  load({ commit }) {
    return axios.get(zRoute('ajax.profiles.home'))
      .then((response) => {
        let profiles = response.data.data;
        commit('setProfiles', profiles);

        let temp = profiles.slice(0);
        let randomProfiles = [];
        do {
          let rand = Math.floor(Math.random() * temp.length);
          randomProfiles.push(temp[rand]);
          temp.splice(rand, 1);
        } while (temp.length > 0);

        commit('setRandomProfiles', randomProfiles);
      });
  },
};

// mutations
const mutations = {
  setProfiles: (state, profiles) => {
    state.profiles = profiles;
  },
  setRandomProfiles: (state, randomProfiles) => {
    state.randomProfiles = randomProfiles;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
